import React, { useCallback, useMemo, useState } from 'react'
import styled from '@emotion/styled'
import ReactResizeDetector from 'react-resize-detector/build/withPolyfill'

export default function AnimateAutoHeight({ children }) {
  const [height, setHeight] = useState('auto')
  const onResize = useCallback(
    (width, newHeight) => {
      setHeight(newHeight)
    },
    [setHeight]
  )
  const style = useMemo(() => ({ height }), [height])

  return (
    <Transition style={style}>
      <div className="relativeContainer">
        <ReactResizeDetector handleHeight onResize={onResize} />
        {children}
      </div>
    </Transition>
  )
}

const Transition = styled('div')`
  transition: height ${({ duration = 300 }) => duration}ms ease;

  .relativeContainer {
    position: relative;
  }
`
